const postPrev = document.getElementById('postPrev');
const postNext = document.getElementById('postNext');

if (postPrev || postPrev) {
  if (!postPrev.children.length) {
    postPrev.style.visibility = 'hidden';
  }

  if (!postNext.children.length) {
    postNext.style.visibility = 'hidden';
  }

  if (!postPrev.children.length && !postNext.children.length) {
    postPrev.parentNode.removeChild(postPrev);
    postNext.parentNode.removeChild(postNext);
  }
}

const pages = document.getElementsByClassName('page');
const previouspostslink = document.getElementsByClassName('previouspostslink');
const nextpostslink = document.getElementsByClassName('nextpostslink');

for (let i = 0, l = pages.length; i < l; i++) {
  const num = document.createElement('span');
  num.classList.add('num');
  num.textContent = pages[i].textContent;

  pages[i].appendChild(num);
}

if (previouspostslink.length) {
  const prev = document.createElement('div');
  const prevImg = document.createElement('img');
  prev.classList.add('num');
  prevImg.classList.add('prev-img');
  prevImg.src = '/wp-content/themes/sp/dist/img/icon-arrow-pager-prev.svg';
  prevImg.classList.add('icon-prev');
  prev.classList.add('num');

  prev.appendChild(prevImg);
  previouspostslink[0].appendChild(prev);
}

if (nextpostslink.length) {
  const next = document.createElement('div');
  const nextImg = document.createElement('img');
  next.classList.add('num');
  nextImg.classList.add('next-img');
  nextImg.src = '/wp-content/themes/sp/dist/img/icon-arrow-pager-next.svg';
  nextImg.classList.add('icon-next');
  next.classList.add('num');

  next.appendChild(nextImg);
  nextpostslink[0].appendChild(next);
}